import React from 'react';
import Input from '../../../shared/forms/Input';
import ProfilePasswordInput from './ProfilePasswordInput';
import Modal, { ModalCloseButton } from '../../../shared/modals/Modal';

const AddExtraUserModal = ({ setVisible, addUser }) => {
  const [fullName, setFullName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const closeModal = () => setVisible(false);

  return (
    <Modal isOpen={true} onClose={closeModal} className="modal--compact modal--full-height">
      <div className="modal">
        <div className="modal__header">
          <h3 className="margin-none">Add an extra user</h3>
          <ModalCloseButton
            onClick={closeModal}
            label="Close add extra user modal"
          />
        </div>

        <div className="modal__body">
          <form
            id="add-extra-user-form"
            onSubmit={(e) => {
              e.preventDefault();
              if (password === confirmPassword) {
                addUser(fullName, email, password);
                closeModal();
              }
            }}
          >
            <div className="modal-section">
              <h4 className="modal-section__title">User details</h4>

              <div className="field-stack">
                <Input label="Full name" onChange={(e) => setFullName(e.target.value)} />
              </div>

              <div className="field-stack">
                <Input label="Email" onChange={(e) => setEmail(e.target.value)} />
              </div>

              <div className="field-stack">
                <ProfilePasswordInput label="Password" onChange={(e) => setPassword(e.target.value)} />
              </div>

              <div className="field-stack">
                <ProfilePasswordInput
                  label="Confirm password"
                  target={password}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
          </form>
        </div>

        <div className="modal__footer">
          <button
            type="button"
            className="btn secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button type="submit" form="add-extra-user-form" className="btn primary">
            Add User
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddExtraUserModal;
